import React, { useContext, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "@reach/router";
import classNames from "classnames";
import { makeStyles } from "@material-ui/styles";
import AppBar from "@material-ui/core/AppBar";
import { Button } from "@mantine/core";
import Toolbar from "@material-ui/core/Toolbar";
import { MenuButton } from "./UIComponents";
import Spinner from "../spinner";
import { THEME } from "../../infrastructure/reducer";
import { AppContext, TOGGLE_MENU } from "../../context";
import MobileMenu from "../../account/AccountNav/mobileMenu";

const useStyles = makeStyles((theme) => ({
  container: {
    boxShadow: "none",
    backgroundColor: theme.app.background[1],
    borderBottom: `1px solid ${theme.app.borderColorLight}`,
    color: theme.app.color,
    height: "64px",
  },
  toolbar: {
    height: "100%",
    "@media(max-width: 768px)": {
      padding: "0 1rem",
    },
  },
  logoContainer: {
    "& a": { display: "flex", height: "100%", alignItems: "center" },
  },
  logo: {
    height: "40px",
    width: "auto",
    "@media(max-width: 667px)": {
      height: "35px",
    },
  },

  loginContainer: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  button: {
    color: theme.app.labelColor,
    "&:hover": {
      backgroundColor: theme.app.hoverBackground[1],
    },
  },
}));

const Header = ({ userManager }) => {
  const [busy, setBusy] = useState(false);
  const { theme, config, auth, language } = useSelector((state) => ({
    theme: state.cookies[THEME],
    config: state.infrastructure.config,
    auth: state.oidc.user !== null && !state.oidc.user.expired,
    language: state.language,
  }));
  const { ctx: state, dispatch } = useContext(AppContext);
  const classes = useStyles({ isLoggedIn: auth });
  const toggleMenu = () => {
    dispatch({ type: TOGGLE_MENU });
  };
  const getLogo = () =>
    config.logo?.src
      ? config.logo.src
      : theme === "light"
      ? "/ee-static/members/Images/logo.svg"
      : "/ee-static/members/Images/logo_dark.svg";

  const labelMenu = state.menuOpen ? language.CloseMenu : language.OpenMenu;

  useEffect(() => {
    if (busy) {
      userManager.signinRedirect();
    }
  }, [busy, userManager]);

  useEffect(() => {
    const params = new URL(document.location).searchParams;
    if (params.get("redirect") === "loginRedirectFromBooking") {
      userManager.signinRedirect();
    }
  }, [userManager]);

  if (busy) return <Spinner />;

  return (
    <AppBar
      position="static"
      className={classNames(classes.container, "header__container")}
    >
      <Toolbar className={classNames(classes.toolbar, "header__toolbar")}>
        <div
          className={classNames(
            classes.logoContainer,
            "header__logo-container"
          )}
        >
          <Link to={`${process.env.PUBLIC_URL}/`}>
            <img
              src={getLogo()}
              className={classNames(classes.logo, "header__logo")}
              alt={(language.Nav && language.Nav.Home) || "Hem"}
            />
          </Link>
        </div>
        {config.hideLogin ? (
          <div />
        ) : (
          <div
            className={classNames(
              classes.loginContainer,
              "header__login-container"
            )}
          >
            {!auth && (
              <Button
                onClick={() => setBusy(true)}
                className={classNames(classes.button, "header__logout-button")}
                variant="subtle"
              >
                <div>{language.Login}</div>
              </Button>
            )}
          </div>
        )}
        {!auth && (
          <MenuButton toggle={toggleMenu} isLoggedIn={auth} label={labelMenu} />
        )}
        {auth && <MobileMenu userManager={userManager} />}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
